<template lang="pug">
v-container.appcard
  v-hover(v-slot:default="{ hover }")
    v-card.datacard.d-flex.flex-column(hover :flat="flat" :outlined="outlined" :href="to" @click.stop target="_blank")
      v-card-title
        .title {{title}}
      v-card-text
        v-card(outlined)
          v-img(:src="image"  height="300px")
          v-fade-transition
            v-overlay(v-if="hover" absolute)
              v-btn(:href="to" target="_blank") Visit website
      v-card-actions(style="height:52px")
        tooltip-btn(v-if="collection_id" label="View Underlying Datasets in Collection" icon="mdi-information-outline" :to="{name:'collection',params:{id:collection_id}}")
        div(v-if="dataset")
          tooltip-btn(v-if="dataset.dataset_id" label="View Underlying Dataset Info" icon="mdi-information-outline" :to="{name:'dataset',params:{id:dataset.dataset_id},query:{tab:'2'}}")
          tooltip-btn(v-if="dataset.dataset_id" label="View Data Table" icon="mdi-table" :to="{name:'dataview',params:{datasetId:dataset.dataset_id}}")
          tooltip-btn(v-if="dataset.url" label="View API" icon="mdi-code-json" :href="dataset.url" @click.stop)
          tooltip-btn(v-if="dataset.download_url" label="Download Full Dataset" icon="mdi-download-outline" :href="dataset.download_url" @click.stop)
</template>

<script>
import TooltipBtn from './TooltipBtn.vue'

export default {
  components: { TooltipBtn },
  props: {
    title: String,
    description: String,
    to: String,
    image: String,
    dataset: Object,
    collection_id: Number,
    rows: String,
    hoverDetails: Boolean,
    showDetails: Boolean,
    showNav: Boolean,
    showViewNav: Boolean,
    flat: Boolean,
    outlined: Boolean,
    dense: Boolean
  },
  data: () => ({
    overlay: false
  }),
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
};
</script>

<style lang="stylus">
.appcard {
  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align:center
    width: 100%
  }

  .description {
    word-break: normal;
    line-height: 22px;
  }
}
</style>